import styled from 'styled-components';

const Button = styled.button`
  width: ${(props) => props.theme.width};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: ${(props) => props.theme.padding};
  border: ${(props) => props.theme.border};
  border-radius: 4px;
  color: ${(props) => props.theme.color};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  & cc-icon {
    color: ${(props) => props.theme.coloricon} !important;
  }

  &:hover {
    background-color: ${(props) => props.theme.backgroundColorHover};
    color: ${(props) => props.theme.colorHover};
    outline: none;
    box-shadow: none;
  }
  &:focus {
    background-color: ${(props) => props.theme.backgroundColorFocus};
    color: ${(props) => props.theme.colorFocus};
    outline: 2px solid white;
    box-shadow: 0 0 0 4px ${(props) => props.theme.backgroundColorFocus};
    & cc-icon {
      color: #fff !important;
    }
  }
  &:active {
    background-color: ${(props) => props.theme.backgroundColorActive};
    color: ${(props) => props.theme.colorActive};
    outline: none;
    box-shadow: none;
    & cc-icon {
      color: ${(props) => props.theme.colorActive} !important;
    }
  }
`;

export default Button;
